// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.dialogbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(236, 236, 236, 0.9);
  z-index: 99999;
}
.dialogbox__wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 30px;
}
.dialogbox__inner {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.dialogbox__inner[data-width=small] {
  width: min(490px, 100%);
}
.dialogbox__inner[data-width=medium] {
  width: min(600px, 100%);
}
.dialogbox__hdr {
  padding: 15px 30px;
  border-bottom: 1px solid #ddd;
  position: relative;
}
.dialogbox__hdr h2 {
  font-size: 17px;
  line-height: 1.3;
  font-weight: 400;
}
.dialogbox__ftr {
  border-top: 1px solid #ddd;
}
.dialogbox .dialogbox__steps :is(ul, ol):last-child {
  margin-bottom: 0;
}
.dialogbox .dialogbox__steps li {
  font-size: 12px;
}
.dialogbox__smalllabel {
  font-size: 12px;
  font-weight: 400;
}
.dialogbox label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 15px;
  font-weight: 700;
  margin-top: 0;
}
.dialogbox label:last-child {
  margin-bottom: 0;
}
.dialogbox select,
.dialogbox input[type=text] {
  height: 35px;
  padding: 3px 10px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
}
.dialogbox select:focus,
.dialogbox input[type=text]:focus {
  outline: none;
}
.dialogbox input[type=radio] {
  margin: 0 5px 0 0;
  position: relative;
  top: 2px;
}
.dialogbox__dpsteps {
  counter-reset: section;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dialogbox__dpsteps-hdr::before {
  counter-increment: section;
  content: counters(section, ".") ". ";
  font-weight: 700;
}
.dialogbox__close {
  --cSize: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  width: var(--cSize);
  height: var(--cSize);
  padding: 0;
  border: 0;
  background-color: transparent;
  opacity: 0.2;
  transition: 0.3s;
  cursor: pointer;
}
.dialogbox__close:hover {
  opacity: 0.4;
}
.dialogbox__close::before, .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 2px;
  height: 100%;
  background-color: #000;
  border-radius: 2px;
}
.dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}

.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
.list-group a {
  color: #fff;
}
.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  border-radius: 4px;
}

.bottom-table th {
  background-color: #f1f2f2;
}

.pdf-modal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/dialogbox/volume-pricing-popup/pricing-schedule-popup/pricing-schedule-popup.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AAgZJ;AA9YI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAgZR;AA7YI;EACI,kBAAA;EACA,wCAAA;AA+YR;AA7YQ;EACI,uBAAA;AA+YZ;AA5YQ;EACI,uBAAA;AA8YZ;AA1YI;EACI,kBAAA;EACA,6BAAA;EACA,kBAAA;AA4YR;AA1YQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AA4YZ;AAxYI;EACI,0BAAA;AA0YR;AArYQ;EACI,gBAAA;AAuYZ;AApYQ;EACI,eAAA;AAsYZ;AAlYI;EACI,eAAA;EACA,gBAAA;AAoYR;AAjYI;EACI,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAmYR;AAjYQ;EACI,gBAAA;AAmYZ;AA/XI;;EAEI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AAiYR;AA/XQ;;EACI,aAAA;AAkYZ;AA9XI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AAgYR;AA7XI;EAEI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AA8XR;AA1XY;EACI,0BAAA;EACA,oCAAA;EACA,gBAAA;AA4XhB;AAvXI;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAyXR;AAvXQ;EACI,YAAA;AAyXZ;AAtXQ;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAuXZ;AApXQ;EACI,8CAAA;AAsXZ;;AAjXA;EACI,eAAA;EACA,mBAAA;AAoXJ;AAlXI;EACI,WAAA;AAoXR;AAjXI;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAiXN;;AA7WA;EACI,yBAAA;AAgXJ;;AA7WA;EACI,aAAA;AAgXJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n.dialogbox {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgb(236 236 236 / 90%);\n    z-index: 99999;\n\n    &__wrapper {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        overflow-y: auto;\n        padding: 30px;\n    }\n\n    &__inner {\n        border-radius: 4px;\n        box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\n        &[data-width=\"small\"] {\n            width: min(490px, 100%);\n        }\n\n        &[data-width=\"medium\"] {\n            width: min(600px, 100%);\n        }\n    }\n\n    &__hdr {\n        padding: 15px 30px;\n        border-bottom: 1px solid $clrDarkGray1;\n        position: relative;\n\n        h2 {\n            font-size: 17px;\n            line-height: 1.3;\n            font-weight: 400;\n        }\n    }\n\n    &__ftr {\n        border-top: 1px solid $clrDarkGray1;\n    }\n\n    .dialogbox__steps {\n\n        :is(ul, ol):last-child {\n            margin-bottom: 0;\n        }\n\n        li {\n            font-size: 12px;\n        }\n    }\n\n    &__smalllabel {\n        font-size: 12px;\n        font-weight: 400;\n    }\n\n    label {\n        display: inline-block;\n        max-width: 100%;\n        margin-bottom: 15px;\n        font-weight: 700;\n        margin-top: 0;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n\n    select,\n    input[type=\"text\"] {\n        height: 35px;\n        padding: 3px 10px;\n        width: 100%;\n        background-color: #fff;\n        border: 1px solid $clrDarkGray1;\n\n        &:focus {\n            outline: none;\n        }\n    }\n\n    input[type=\"radio\"] {\n        margin: 0 5px 0 0;\n        position: relative;\n        top: 2px;\n    }\n\n    &__dpsteps {\n\n        counter-reset: section;\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n\n        &-hdr {\n\n            &::before {\n                counter-increment: section;\n                content: counters(section, \".\") \". \";\n                font-weight: 700;\n            }\n        }\n    }\n\n    &__close {\n        --cSize: 16px;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 15px;\n        width: var(--cSize);\n        height: var(--cSize);\n        padding: 0;\n        border: 0;\n        background-color: transparent;\n        opacity: 0.2;\n        transition: 0.3s;\n        cursor: pointer;\n\n        &:hover {\n            opacity: 0.4;\n        }\n\n        &::before,\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) rotate(-45deg);\n            width: 2px;\n            height: 100%;\n            background-color: #000;\n            border-radius: 2px;\n        }\n\n        &::after {\n            transform: translate(-50%, -50%) rotate(45deg);\n        }\n    }\n}\n\n.list-group {\n    padding-left: 0;\n    margin-bottom: 20px;\n\n    a {\n        color: #fff;\n    }\n\n    &-item.active,\n    &-item.active:hover,\n    &-item.active:focus {\n      z-index: 2;\n      color: #fff;\n      background-color: #337ab7;\n      border-color: #337ab7;\n      border-radius: 4px;\n    }\n}\n\n.bottom-table th {\n    background-color: #f1f2f2;\n}\n\n.pdf-modal {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
